import { useQuery, useMutation } from "@tanstack/react-query"
import { reportApi } from "@/services/report-api"
import { queryKeys } from "./query-keys"
import { useAuthReady } from "./use-auth-ready"
import { useCurrentTenant } from "./use-current-tenant"

export function useReports() {
  const isAuthReady = useAuthReady()
  const { data: tenant } = useCurrentTenant()

  return useQuery({
    queryKey: queryKeys.reports.list(tenant?.id),
    queryFn: () => reportApi.getAllReports(),
    enabled: isAuthReady && tenant !== undefined,
    throwOnError: true,
  })
}

export function useReportParameters(
  reportPath: string,
  parameters?: Record<string, string | string[]>
) {
  const isAuthReady = useAuthReady()

  return useQuery({
    queryKey: queryKeys.reports.parameters(reportPath, parameters),
    queryFn: () => reportApi.getReportParameters(reportPath, parameters),
    enabled: isAuthReady && !!reportPath,
  })
}

export function useGeneratePDF() {
  return useMutation({
    mutationFn: ({
      reportClassName,
      parameters,
    }: {
      reportClassName: string
      parameters: Record<string, string>
    }) => reportApi.generatePDF(reportClassName, parameters),
  })
}
